import {
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { BaseDialog } from "./base";

export function ConfirmDialog({
  open,
  title,
  description,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  onConfirm,
  onClose,
  loading = false,
}) {
  return (
    <BaseDialog open={open} onClose={onClose} title={title}>
      <DialogContent>
        <DialogContentText>{description}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose} disabled={loading}>
          {cancelLabel}
        </Button>
        <Button variant="contained" onClick={onConfirm} disabled={loading}>
          {confirmLabel}
        </Button>
      </DialogActions>
    </BaseDialog>
  );
}
